import { isPlatformBrowser } from "@angular/common";
import {
    inject,
    Injectable,
    PLATFORM_ID,
} from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    // eslint-disable-next-line no-restricted-syntax
    providedIn: "root",
})
export class AntifraudService {
    private readonly platformId = inject(PLATFORM_ID);
    private loaded = false;

    public init(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        if (!environment.features?.antifraud?.includes("v1")) {
            return;
        }

        const load = (): void => {
            if (this.loaded) {
                return;
            }
            this.loaded = true;
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            (function(a: string, w: Window & Record<string, unknown>, d: Document, t: string, s: string, b: string) {
                w["afto"] = a;
                // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                (w[a] as (k: string, v?: unknown) => void) = w[a] as (k: string, v?: unknown) => void || function(k: string, v?: unknown) {
                    (w[a] as Record<string, unknown>)["q"] = (w[a] as Record<string, unknown>)["q"] || {};
                    ((w[a] as Record<string, unknown>)["q"] as Record<string, unknown>)[k] = v || 1;
                };
                ((w[a] as Record<string, unknown>)["q"] as Record<string, unknown>) = { be: b };
                const e = d.createElement(t) as HTMLScriptElement;
                const m = d.getElementsByTagName(t)[0];
                e.async = true;
                e.src = atob(s);
                // @ts-ignore
                m.parentNode?.insertBefore(e, m);
                // @ts-ignore
            })("aft", window as Window & Record<string, unknown>, document, "script",
                "aHR0cHM6Ly9mcy5sNGI2NS5mcm9nby1hZnQudGVjaC9mcC5qcw==",
                "aHR0cHM6Ly9mLmw0YjY1LmZyb2dvLWFmdC50ZWNo");
            // @ts-ignore
            const aft = (window as Record<string, unknown>)["aft"] as (k: string, v?: unknown) => void;
            aft("apiKey", "695519b5b7b585abdc370fee");
            aft("manual");
            aft("start");
            aft("send");
        };

        window.addEventListener("load", () => {
            if ("requestIdleCallback" in window) {
                requestIdleCallback(load, { timeout: 5000 });
            } else {
                setTimeout(load, 1000);
            }
        }, { once: true });
    }
}
